import { render, staticRenderFns } from "./FuncionesGlobales.vue?vue&type=template&id=976d92a6&"
import script from "./FuncionesGlobales.vue?vue&type=script&lang=ts&"
export * from "./FuncionesGlobales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports